import sandwitch from "../assets/images/cuisines/default.jpeg"
interface CuisinesProps {
  index: number;
  name: string;
  image: string;
  _id?: string;
  onClick?: (cuisineId: string, cuisineName: string) => void;
}

const Cuisines = ({ index, name, image, _id, onClick }: CuisinesProps) => {
  const handleClick = () => {
    if (onClick && _id) {
      onClick(_id, name);
    }
  };

  return (
    <div 
      className={`flex flex-col items-center w-full ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`} 
      key={index}
      onClick={handleClick}
    >
      <img
        src={image ?? sandwitch}
        alt="cuisines"
        className="w-full aspect-square object-cover rounded-[10px]"
      />
      <span className="text-gray-900 dark:text-white font-urbanist text-xs md:text-sm font-medium text-center mt-1 w-full">
        {name}
      </span>
    </div>
  );
};

export default Cuisines;
